import { createReducer, on } from '@ngrx/store';
import { loadProfileLists, loadProfileListsSuccess, loadProfileListsFailure } from './profileList.actions';

export interface ProfileListState {
  profileLists: {
    list: any[];
    profileLists: any[];
    loading: boolean;
    success?: boolean;
    error: any;
  };
}

export const initialState: ProfileListState = {
  profileLists: {
    list: [],
    profileLists: [],
    loading: false,
    error: null
  }
};

export const profileListReducer = createReducer(
  initialState,
  on(loadProfileLists, (state) => {
    // console.log('loadProfileLists action triggered', state);
    return {
      ...state,
      profileLists: { ...state.profileLists, loading: true, error: null }
    };
  }),
  on(loadProfileListsSuccess, (state, { profileLists }) => {
    // console.log('loadProfileListsSuccess action triggered', countries);
    return {
      ...state,
      profileLists: { ...state.profileLists, profileLists: profileLists, loading: false, success: true, error: null }
    };
  }),
  on(loadProfileListsFailure, (state, { error }) => {
    // console.error('loadProfileListsFailure action triggered', error);
    return {
      ...state,
      profileLists: { ...state.profileLists, error: error, loading: false }
    };
  })
);
